import {
  apiClient,
  type CustomerContractListExEntity,
  type PageEntity
} from '@/libs/api'
import { type CustomerContractsRequestQuery } from '@/libs/api/types'

export type FetchCustomerContractsQuery = {
  tenantKey: string
  query?: CustomerContractsRequestQuery
}

export type FetchCustomerContractsResponse = {
  data: CustomerContractListExEntity[]
  pagination: PageEntity | null
}

/**
 * 請求契約一覧の取得API
 */
export const fetchCustomerContracts = async (
  { tenantKey, query }: FetchCustomerContractsQuery,
  signal?: AbortSignal
): Promise<FetchCustomerContractsResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .customer_contracts.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
